// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TusQ","title":"styles_title__37JrL"};